import { render, staticRenderFns } from "./AdminAccreditations.vue?vue&type=template&id=1d2dbb96&scoped=true"
import script from "./AdminAccreditations.vue?vue&type=script&lang=js"
export * from "./AdminAccreditations.vue?vue&type=script&lang=js"
import style0 from "./AdminAccreditations.vue?vue&type=style&index=0&id=1d2dbb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../BuildingCatalog/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2dbb96",
  null
  
)

export default component.exports